module.exports = __webpack_public_path__ + "static/img/2-s.98c2aa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hero/2-s.jpg
// module id = ed0U
// module chunks = 0